"use client";

import Link from "next/link";

// PaymentFailedBanner — fires during the 3-day grace period for
// paid users whose last Stripe charge failed. Banner registry
// condition: profile.grace_until > now().
//
// dismissPolicy: 'never' (priority 1, highest) — user can't hide
// this one. Their sub is about to lapse; they need to see it.
//
// Session 46 C4.

export default function PaymentFailedBanner({ profile }) {
  // Days remaining until grace expires (rounded up, min 1)
  let daysLeft = 3;
  try {
    if (profile?.grace_until) {
      const remainingMs = new Date(profile.grace_until).getTime() - Date.now();
      daysLeft = Math.max(1, Math.ceil(remainingMs / 86400000));
    }
  } catch {}
  const dayWord = daysLeft === 1 ? "day" : "days";

  return (
    <div
      role="alert"
      aria-label="Payment failed"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "var(--space-3)",
        padding: "var(--space-3) var(--space-4)",
        background: "var(--color-error-soft, #fbecec)",
        border: "1px solid var(--color-error, #c44)",
        borderRadius: "var(--radius-md)",
        marginBottom: "var(--space-4)",
        fontFamily: "var(--font-primary)",
      }}
    >
      <div style={{ fontSize: "var(--font-size-sm)", color: "var(--color-text)", lineHeight: 1.5 }}>
        <span style={{ fontWeight: "var(--font-weight-semibold)" }}>Card declined.</span>{" "}
        {daysLeft} {dayWord} to fix it before your plan pauses.
      </div>
      <Link
        href="/settings/billing"
        style={{
          display: "inline-block",
          padding: "var(--space-2) var(--space-4)",
          background: "var(--color-text)",
          color: "var(--color-bg)",
          borderRadius: "var(--radius-sm)",
          fontSize: "var(--font-size-sm)",
          fontWeight: "var(--font-weight-medium)",
          textDecoration: "none",
          whiteSpace: "nowrap",
          flexShrink: 0,
        }}
      >
        Update card
      </Link>
    </div>
  );
}
